import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const VAT_PAYER_STATUS = {
  YES: 'yes',
  NO: 'no',
} as const;

export const VAT_PAYER_STATUS_NAME = 'vat_payer_status';
export const VAT_PAYER_STATUS_NAME_COMPLEMENTARY =
  'vat_payer_status_complementary';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupVATTaxpayerStatus: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary
      ? VAT_PAYER_STATUS_NAME_COMPLEMENTARY
      : VAT_PAYER_STATUS_NAME);

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{i18n.t('Jesteś podatnikiem VAT?')}</FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              data-testid="radio-group-vat-payer-status"
            >
              <RadioItem
                value={VAT_PAYER_STATUS.YES}
                label={i18n.t('Tak')}
                data-testid="radio-item-vat-payer-status-yes"
              />
              <RadioItem
                value={VAT_PAYER_STATUS.NO}
                label={i18n.t('Nie')}
                data-testid="radio-item-vat-payer-status-no"
              />
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
